import ct, { Timezone } from 'countries-and-timezones'

export type { Timezone } from 'countries-and-timezones'

export const getAllTimezones = (): Timezone[] => {
  return Object.values(ct.getAllTimezones()).map((timezone) => timezone)
}
